module.exports = __webpack_public_path__ + "img/s5.000147a4.png";